<template>
	<div class="foot">
		<img src="@/assets/foot-up.png" alt="" class="f-up" />
		<!-- <img src="@/assets/foot-down.png" alt="" class="f-down"> -->
		<div class="foot-nav">
			<b-row class="justify-content-between">
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="main-title">
						<router-link to="/" tag="div" class="router-link">
							<b-row>
								<img class="icon" src="@/assets/icon.png" alt="" />

								<div class="title">
									<p class="ch">利澤國際偶戲藝術村</p>
									<p class="en">Lize Puppet Art Colony</p>
								</div>
							</b-row>
						</router-link>
					</h3>
					<p class="main-content">
						26841宜蘭縣五結鄉利澤東路37號<br />
						No.37, Lize E. Road, Wujie Township,<br />
						Yilan County,TAIWAN 26841<br />
						Phone: +886-3-950-1977<br />
						Fax: +886-3-950-0051<br />
						Email: lize.puppet@gmail.com<br /><br />偶戲村參訪採線上<a
							href="https://lizepuppet.com.tw/reservation/play"
							target="_blank"
							>團體預約制</a
						>，或請來電洽詢<a href="tel:03-9501977">03-9501977</a>。<br />

						<!-- 週一		    10:00-17:00<br>
              週五		    10:00-17:00<br>
              週六		    10:00-17:00<br>
              週日		    10:00-17:00<br><br>

              週二・週三・週四	公休 -->
					</p>
				</b-col>
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="title">關於偶戲村</h3>
					<ul class="content">
						<router-link to="/about" tag="li" class="router-link"
							>關於「利澤國際偶戲藝術村」</router-link
						>
						<!-- <router-link to="/about/info" tag="li" class="router-link">參觀資訊</router-link> -->
						<router-link to="/about/corner" tag="li" class="router-link"
							>空間介紹</router-link
						>
						<router-link to="/about/environment" tag="li" class="router-link"
							>周邊環境介紹</router-link
						>
						<router-link to="/about/report" tag="li" class="router-link"
							>交通資訊</router-link
						>
						<li>
							<a
								href="http://www.puppetx2.com.tw/"
								target="_blank"
								style="color: #878787"
								>無獨有偶工作室劇團</a
							>
						</li>
					</ul>
				</b-col>
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="title">展演活動</h3>
					<ul class="content">
						<router-link to="/event/list" tag="li" class="router-link"
							>活動回顧</router-link
						>
						<router-link to="/event/news" tag="li" class="router-link"
							>最新消息</router-link
						>
					</ul>
				</b-col>
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="title">駐村計畫</h3>
					<ul class="content">
						<router-link to="/program/apply" tag="li" class="router-link"
							>駐村藝術家計畫</router-link
						>
						<router-link to="/program/list" tag="li" class="router-link"
							>駐村藝術家列表</router-link
						>
						<router-link to="/program/activities" tag="li" class="router-link"
							>駐村活動</router-link
						>
					</ul>
				</b-col>
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="title">活動預約</h3>
					<ul class="content">
						<!-- <router-link to="/reservation/secret" tag="li" class="router-link">預約「操偶師職人實境體驗」</router-link> -->
						<router-link to="/reservation/play" tag="li" class="router-link"
							>參訪與客製活動</router-link
						>
						<li class="router-link">
							<a
								href="https://lizepuppet.oen.tw/"
								target="_blank"
								rel="noopener"
								style="color: #878787;text-decoration: none;"
								>近期活動</a
							>
						</li>
					</ul>
				</b-col>
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="title">場地租借</h3>
					<ul class="content">
						<router-link to="/rent" tag="li" class="router-link"
							>場地介紹</router-link
						>
						<router-link to="/rent" tag="li" class="router-link"
							>租借流程與辦法</router-link
						>
					</ul>
				</b-col>
				<b-col lg="auto" md="5" class="nav-item">
					<h3 class="title">支持我們</h3>
					<ul class="content">
						<router-link to="/support/team" tag="li" class="router-link"
							>超偶特攻隊</router-link
						>
						<router-link to="/support/club" tag="li" class="router-link"
							>偶迷俱樂部</router-link
						>
					</ul>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "foot",
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.foot-nav {
	padding-bottom: 100px !important;
	@media (min-width: 790px) {
		padding-bottom: 50px !important;
	}
}
.community {
	li {
		margin-bottom: 5px;
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'
.foot
  position: relative
  z-index: 300
  .foot-nav
    position: absolute
    top: 0
    left: 0
    width: 100%
    color: white
    padding: 0px 50px 50px 50px
    background-image: url('../assets/foot-down.png')
    background-size: cover
    .nav-item
      margin-top: 50px
      padding: 0 5px
      .main-title
        color: $font-color-white
        font-size: $font-size-3
        margin-bottom: 18px
        .icon
          +size(47px, 47px)
          margin-bottom: 10px
          margin-right: 10px
        .ch
          margin-bottom: 8px
      .title
        color: $font-color-white
        font-size: $font-size-4
        margin-bottom: 18px
      .main-content
        color: $font-color-gray
        font-size: $font-size-5
        line-height: 1.5
      .content
        color: $font-color-gray
        font-size: $font-size-5
        line-height: 2
      .router-link
        cursor: pointer
  .f-up
    position: absolute
    width: 100%
    height: auto
    left: 0%
    bottom: -2px
  .f-down
    width: 100%
    height: auto
    position: relative
    bottom: 0
  .social
    +size(30px, 30px)
</style>



// WEBPACK FOOTER //
// src/components/foot.vue